module.exports = __webpack_public_path__ + "img/slide-2.864b3c1e.png";